import './assets/scripts/App'
import './assets/scss/main.scss'